export const STATUS_LABEL = {
  ACTIVE: 'Ativo',
  IN_PROGRESS: 'Em andamento',
  CANCELLED: 'Encerrado',
  FINISHED: 'Concluído'
}

export const CAMPAIGN_STATUS = {
  ACTIVE: 'ACTIVE',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELLED: 'CANCELLED',
  FINISHED: 'FINISHED'
}

export const STATUS_ABLE_TO_FINISH_CAMPAIGN = ['ACTIVE', 'IN_PROGRESS']

export const STATUS_ABLE_TO_EDIT_CAMPAIGN = ['ACTIVE', 'IN_PROGRESS']

export const CAMPAIGN_TYPE = Object.freeze({
  POINT: 'POINT',
  MULTIPLIER: 'MULTIPLIER'
} as const)

export type TypesEnum = (typeof CAMPAIGN_TYPE)[keyof typeof CAMPAIGN_TYPE]

export const CAMPAIGN_TYPES_LIST = [
  {
    label: 'Pontuação simples',
    value: CAMPAIGN_TYPE.POINT
  },
  {
    label: 'Multiplicador de pontos',
    value: CAMPAIGN_TYPE.MULTIPLIER
  }
]

export const CAMPAIGN_MULTIPLIER_VALUES = [
  {
    label: 'Pontos x 1,5',
    value: 0.5
  },
  {
    label: 'Pontos x 2,0',
    value: 1
  },
  {
    label: 'Pontos x 2,5',
    value: 1.5
  },
  {
    label: 'Pontos x 3,0',
    value: 2
  },
  {
    label: 'Pontos x 4,0',
    value: 3
  },
  {
    label: 'Pontos x 5,0',
    value: 4
  },
  {
    label: 'Pontos x 6,0',
    value: 5
  },
  {
    label: 'Pontos x 7,0',
    value: 6
  },
  {
    label: 'Pontos x 8,0',
    value: 7
  },
  {
    label: 'Pontos x 9,0',
    value: 8
  },
  {
    label: 'Pontos x 10,0',
    value: 9
  }
]

export const POINTS_TYPE = Object.freeze({
  DEFAULT: 'DEFAULT',
  TIER_RULE: 'TIER_RULE',
  DAYS_CALENDAR: 'DAYS_CALENDAR'
} as const)

export const POINTS_VALIDITY_TYPE = Object.freeze({
  FIXED: 'FIXED',
  FLEXIBLE: 'FLEXIBLE'
} as const)

export const POINTS_VALIDITY_OPTIONS = [
  { id: 'points-validity-fixed', label: 'Data fixa', value: POINTS_VALIDITY_TYPE.FIXED },
  { id: 'points-validity-flexible', label: 'Data flexível', value: POINTS_VALIDITY_TYPE.FLEXIBLE }
]

export const FLEXIBLE_POINTS_RULE_LIST = [
  {
    label: 'Regra do programa (12 meses ou 18 meses)',
    value: POINTS_TYPE.TIER_RULE
  },
  {
    label: 'Dias corridos',
    value: POINTS_TYPE.DAYS_CALENDAR
  }
]

export const CAMPAIGN_AUDIENCE_TYPES_LIST = [
  {
    label: 'Transacional',
    value: 'TRANSACTIONAL'
  },
  {
    label: 'Não transacional',
    value: 'NON_TRANSACTIONAL'
  }
]

export const AUDIENCE_TYPES_LIST = [
  {
    label: 'Segmentada',
    value: 'SEGMENTED'
  },
  {
    label: 'Toda base Fidelidade',
    value: 'ALL'
  }
]
